export const userAvatarConfig = {
    dimensions: { width: 1080, height: 1080 },
};
